import { render, staticRenderFns } from "./pg-updlang.vue?vue&type=template&id=43dd8d3a&scoped=true"
import script from "./pg-updlang.vue?vue&type=script&lang=js"
export * from "./pg-updlang.vue?vue&type=script&lang=js"
import style1 from "./pg-updlang.vue?vue&type=style&index=1&id=43dd8d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dd8d3a",
  null
  
)

export default component.exports